import Request from './base/Request';
import * as base64 from 'base-64';

class RegisterResultsRequest extends Request {
    constructor(APIURL, header, body) {
        super(APIURL);

        if(!body.requestSeqid || !body.result)
            throw Error('Missing param');
        if(!(['1','2', '3'].includes(String(body.result))))
            throw Error('Wrong reulst');

        this.options = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ...header
            },
            body: JSON.stringify(body)
        };
        this.request = this.request.bind(this);
    }
}

export default RegisterResultsRequest;